import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wallet, Package } from "@phosphor-icons/react";

export default function DriverEarnings() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/driver/my-orders").then((r) => setOrders(r.data));
  }, []);

  const delivered = orders.filter(({ order }) => order.status === "delivered");
  const totalEarned = user?.driver_earnings || 0;

  return (
    <div className="space-y-8">
      <div>
        <span className="label-eyebrow">Earnings</span>
        <h1 className="mt-1 font-display text-5xl">Your money</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="card-panel p-6 bg-[var(--green)] text-white">
          <Wallet size={24} weight="fill" />
          <p className="mt-4 font-display text-5xl">R{totalEarned.toFixed(2)}</p>
          <p className="text-xs font-bold uppercase tracking-widest">Total earned</p>
        </div>
        <div className="card-panel p-6 bg-[var(--blue)] text-white">
          <Package size={24} weight="fill" />
          <p className="mt-4 font-display text-5xl">{delivered.length}</p>
          <p className="text-xs font-bold uppercase tracking-widest">Delivered orders</p>
        </div>
      </div>
      <div>
        <h3 className="label-eyebrow mb-3">Recent deliveries</h3>
        <div className="space-y-2">
          {delivered.length === 0 && (
            <div className="card-panel p-6 text-center text-sm text-[var(--text-2)]">
              No completed deliveries yet.
            </div>
          )}
          {delivered.map(({ order, store }) => (
            <div key={order.order_id} className="card-flat p-4 flex items-center justify-between">
              <div>
                <p className="font-black text-sm">
                  #{order.order_id.slice(-6).toUpperCase()} · {store.name}
                </p>
                <p className="text-xs text-[var(--text-2)] mt-1">{new Date(order.updated_at).toLocaleString()}</p>
              </div>
              <span className="font-display text-xl text-[var(--green)]">
                +R{(order.delivery_fee * 0.8).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
